import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { PREVIEW_COMPANIES_ENDPOINT } from '../../../../../../utility/SourceAPI'

export const getPreviewCompanies = createAsyncThunk('appPreviewCompanies/getPreviewCompanies', async () => {
    const response = await axios.get(PREVIEW_COMPANIES_ENDPOINT)
    return response.data
})

export const getAllCompaniesPreview = createAsyncThunk('appPreviewCompanies/getAllCompaniesPreview', async () => {
    const response = await axios.get(PREVIEW_COMPANIES_ENDPOINT.concat('?include_all=true'))
    return response.data
})

export const getCompaniesPreviewnotEmail = createAsyncThunk('appPreviewCompanies/getCompaniesPreviewnotEmail', async () => {
    const response = await axios.get(PREVIEW_COMPANIES_ENDPOINT.concat('?not_email=true'))
    return response.data
})

export const getPreviewCompaniesTracking = createAsyncThunk('appPreviewCompanies/getPreviewCompaniesTracking', async () => {
    const response = await axios.get(PREVIEW_COMPANIES_ENDPOINT.concat('?is_application_tracking=false'))
    return response.data
})

export const addPreviewCompany = createAsyncThunk('appPreviewCompanies/addPreviewCompany', async (company, { dispatch }) => {
    const response = await axios.post(PREVIEW_COMPANIES_ENDPOINT, company)
    await dispatch(getPreviewCompanies())
    return response.data
})

export const updatePreviewCompany = createAsyncThunk('appPreviewCompanies/updatePreviewCompany', async (data, { dispatch }) => {
    const response = await axios.put(`${PREVIEW_COMPANIES_ENDPOINT}${data.id}`, data)
    await dispatch(getPreviewCompanies())
    return response.data
})

export const updatePreviewCompanywithRFC = createAsyncThunk('appPreviewCompanies/updatePreviewCompanywithRFC', async (data, { dispatch }) => {
    const response = await axios.put(`${PREVIEW_COMPANIES_ENDPOINT}with_rfc/${data.id}`, data)
    await dispatch(getPreviewCompanies())
    return response.data
})

export const applyPreviewCompany = createAsyncThunk('appPreviewCompanies/applyPreviewCompany', async (data, { dispatch }) => {
    const response = await axios.post(`${PREVIEW_COMPANIES_ENDPOINT}apply/${data.id}`, data)
    await dispatch(getPreviewCompanies())

    return response.data
})

export const deletePreviewCompany = createAsyncThunk('appPreviewCompanies/deletePreviewCompany', async (id, { dispatch }) => {
    const response = await axios.delete(`${PREVIEW_COMPANIES_ENDPOINT}${id}`)
    await dispatch(getPreviewCompanies())
    return response.data
})

export const appPreviewCompaniesSlice = createSlice({
    name: 'appPreviewCompanies',
    initialState: {
        data: [],
        previewToTracking: [],
        allCompaniesPreview: [],
        companiesPreviewNotEmail: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getPreviewCompanies.fulfilled, (state, action) => {
            state.data = action.payload
        })
        builder.addCase(getPreviewCompaniesTracking.fulfilled, (state, action) => {
            state.previewToTracking = action.payload
        })
        builder.addCase(getAllCompaniesPreview.fulfilled, (state, action) => {
            state.allCompaniesPreview = action.payload
        })
        builder.addCase(getCompaniesPreviewnotEmail.fulfilled, (state, action) => {
            state.companiesPreviewNotEmail = action.payload
        })
    }
})

export default appPreviewCompaniesSlice.reducer